// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

import CenterWiseLoanProposalActionTypes from './center-wise-loan-proposal.types';

/** ***************** CREATE CENTER WISE LOAN PROPOSAL START *********************** */
export const addCenterWiseLoanPropsalStart = (addData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_START,
	payload: addData,
});

export const addCenterWiseLoanPropsalSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addCenterWiseLoanPropsalFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addCenterWiseLoanPropsalResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addCenterWiseLoanPropsalResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** CREATE CENTER WISE LOAN PROPOSAL END *********************** */

/** ***************** UPDATE CENTER WISE LOAN PROPOSAL START *********************** */
export const updateCenterWiseLoanProposalStart = (updateData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_START,
	payload: updateData,
});

export const updateCenterWiseLoanProposalSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateCenterWiseLoanProposalFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateCenterWiseLoanProposalResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateCenterWiseLoanProposalResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** UPDATE CENTER WISE LOAN PROPOSAL END *********************** */

/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN START *********************** */
export const fetchMembersListForCenterWiseLoanStart = (fetchData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_START,
	payload: fetchData,
});

export const fetchMembersListForCenterWiseLoanSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_SUCCESS,
	payload: successData,
});

export const fetchMembersListForCenterWiseLoanFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_FAILURE,
	payload: failureData,
});

export const fetchMembersListForCenterWiseLoanResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_RESET,
});

export const fetchMembersListForCenterWiseLoanResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_CHANGED,
});

/** ***************** FETCH MEMBERS LIST FOR CENTER WISE LOAN END *********************** */

/** ***************** FETCH CENTER WISE LOAN PROPOSAL START *********************** */
export const fetchCenterWiseLoanProposalStart = (fetchData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_START,
	payload: fetchData,
});

export const fetchCenterWiseLoanProposalSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const fetchCenterWiseLoanProposalFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const fetchCenterWiseLoanProposalResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const fetchCenterWiseLoanProposalResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** FETCH CENTER WISE LOAN PROPOSAL END *********************** */

/*************** START ADD MEMBER BANK DETAILS  ***************/
export const addMemberbankDetailsStart = (fetchData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_START,
	payload: fetchData,
});

export const addMemberbankDetailsSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_SUCCESS,
	payload: successData,
});

export const addMemberbankDetailsFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_FAILURE,
	payload: failureData,
});

export const addMemberbankDetailsResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_RESPONSE_RESET,
});

export const addMemberbankDetailsResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.ADD_MEMBER_BANK_DETAILS_RESPONSE_CHANGED,
});
/*************** END ADD MEMBER BANK DETAILS  ***************/

/*************** START FETCH MEMBER BANK DETAILS  ***************/
export const fetchMemberbankDetailsStart = (fetchData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_START,
	payload: fetchData,
});

export const fetchMemberbankDetailsSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchMemberbankDetailsFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchMemberbankDetailsResponseResetStart = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_RESPONSE_RESET,
});

export const fetchMemberbankDetailsResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.FETCH_MEMBER_BANK_DETAILS_RESPONSE_CHANGED,
});
/*************** START ADD MEMBER BANK DETAILS  ***************/

/*************** START UPDATE CORRECT LOAN START/END DATE FOR MEMBER ***************/
export const updateCorrectLoanStartEndDateForMemberStart = (updateData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_START,
	payload: updateData,
});

export const updateCorrectLoanStartEndDateForMemberSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_SUCCESS,
	payload: successData,
});

export const updateCorrectLoanStartEndDateForMemberFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_FAILURE,
	payload: failureData,
});

export const updateCorrectLoanStartEndDateForMemberResponseReset = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_RESET,
});

export const updateCorrectLoanStartEndDateForMemberResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_CHANGED,
});
/*************** END UPDATE CORRECT LOAN START/END DATE FOR MEMBER ***************/

/*************** START UPDATE CORRECT LOAN FOR OVERALL MEMBER ***************/
export const updateCorrectLoanForOverallMemberStart = (updateData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_START,
	payload: updateData,
});

export const updateCorrectLoanForOverallMemberSuccess = (successData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_SUCCESS,
	payload: successData,
});

export const updateCorrectLoanForOverallMemberFailure = (failureData: any) => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_FAILURE,
	payload: failureData,
});

export const updateCorrectLoanForOverallMemberResponseReset = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_RESET,
});

export const updateCorrectLoanForOverallMemberResponseChanged = () => ({
	type: CenterWiseLoanProposalActionTypes.UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_CHANGED,
});
/*************** END UPDATE CORRECT LOAN FOR OVERALL MEMBER ***************/
